import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../home/components/Footer';

export default function EquipmentRental() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Equipment', icon: 'ri-grid-line' },
    { id: 'surf', name: 'Surfboards', icon: 'ri-surfing-line' },
    { id: 'kite', name: 'Kitesurf', icon: 'ri-kite-line' },
    { id: 'accessories', name: 'Accessories', icon: 'ri-shopping-bag-line' }
  ];

  const equipment = [
    {
      category: 'surf',
      name: 'Softboard 7\'0"',
      description: 'Perfect for beginners, stable and safe',
      price: '€15',
      duration: 'per day',
      image: 'https://public.readdy.ai/ai/img_res/f9b1fd7e661671089e55f0e247bdfd3c.jpg',
      features: ['Soft foam top', 'Very stable', 'Safe for learning']
    },
    {
      category: 'surf',
      name: 'Shortboard 6\'2"',
      description: 'High-performance board for experienced surfers',
      price: '€20',
      duration: 'per day',
      image: 'https://readdy.ai/api/search-image?query=professional-shortboard-surfboard-white-clean-background-performance-surfboard-product-shot-minimal-style&width=600&height=600&seq=shortboard-rental-002&orientation=squarish',
      features: ['Fiberglass construction', 'Maneuverable', 'Advanced riders']
    },
    {
      category: 'surf',
      name: 'Longboard 9\'0"',
      description: 'Classic style, great for small waves',
      price: '€18',
      duration: 'per day',
      image: 'https://readdy.ai/api/search-image?query=classic-longboard-surfboard-clean-white-background-vintage-style-surfboard-product-photography-minimal&width=600&height=600&seq=longboard-rental-003&orientation=squarish',
      features: ['Easy paddling', 'Stable platform', 'All skill levels']
    },
    {
      category: 'kite',
      name: 'Complete Kitesurf Kit',
      description: 'Kite, board, harness, and safety equipment',
      price: '€50',
      duration: 'per day',
      image: 'https://readdy.ai/api/search-image?query=kitesurfing-equipment-set-with-colorful-kite-board-and-harness-on-clean-white-background-product-photography-minimal-style&width=600&height=600&seq=kitesurf-kit-004&orientation=squarish',
      features: ['Latest equipment', 'Multiple kite sizes', 'Full safety gear']
    },
    {
      category: 'kite',
      name: 'Kiteboard Only',
      description: 'Twin-tip board for freestyle and freeride',
      price: '€20',
      duration: 'per day',
      image: 'https://readdy.ai/api/search-image?query=kiteboard-twin-tip-board-clean-white-background-colorful-design-product-photography-minimal-style&width=600&height=600&seq=kiteboard-rental-005&orientation=squarish',
      features: ['Twin-tip design', 'Various sizes', 'Straps included']
    },
    {
      category: 'kite',
      name: 'Kite Only',
      description: 'High-quality kites in various sizes',
      price: '€30',
      duration: 'per day',
      image: 'https://readdy.ai/api/search-image?query=colorful-kitesurfing-kite-on-clean-white-background-product-shot-minimal-style-vibrant-colors&width=600&height=600&seq=kite-rental-006&orientation=squarish',
      features: ['7m to 14m sizes', 'Latest models', 'Bar and lines included']
    },
    {
      category: 'accessories',
      name: 'Wetsuit',
      description: '3/2mm full wetsuit for comfort',
      price: '€10',
      duration: 'per day',
      image: 'https://readdy.ai/api/search-image?query=black-wetsuit-on-clean-white-background-surfing-wetsuit-product-photography-minimal-style&width=600&height=600&seq=wetsuit-rental-007&orientation=squarish',
      features: ['Various sizes', 'Quality neoprene', 'Comfortable fit']
    },
    {
      category: 'accessories',
      name: 'SUP Board',
      description: 'Stand-up paddleboard with paddle',
      price: '€25',
      duration: 'per day',
      image: 'https://readdy.ai/api/search-image?query=stand-up-paddleboard-with-paddle-on-clean-white-background-sup-board-product-photography-minimal-style&width=600&height=600&seq=sup-rental-008&orientation=squarish',
      features: ['Stable design', 'Paddle included', 'Great for exploring']
    },
    {
      category: 'accessories',
      name: 'GoPro Camera',
      description: 'Capture your surf sessions',
      price: '€15',
      duration: 'per day',
      image: 'https://readdy.ai/api/search-image?query=action-camera-gopro-with-waterproof-case-on-clean-white-background-product-photography-minimal-style&width=600&height=600&seq=gopro-rental-009&orientation=squarish',
      features: ['Waterproof case', 'Mounting accessories', 'SD card included']
    }
  ];

  const filteredEquipment = selectedCategory === 'all' 
    ? equipment 
    : equipment.filter(item => item.category === selectedCategory);

  const packages = [
    {
      title: 'Surf Package',
      description: 'Everything you need for a day of surfing',
      price: '€30',
      duration: 'per day',
      includes: ['Surfboard', 'Wetsuit', 'Leash', 'Wax'],
      color: 'teal',
      icon: 'ri-surfing-line'
    },
    {
      title: 'Kitesurf Package',
      description: 'Complete kitesurf setup for experienced riders',
      price: '€60',
      duration: 'per day',
      includes: ['Kite', 'Board', 'Harness', 'Safety equipment'],
      color: 'orange',
      icon: 'ri-kite-line'
    },
    {
      title: 'Weekly Rental',
      description: 'Save 30% with weekly rentals',
      price: 'From €100',
      duration: 'per week',
      includes: ['Any equipment', 'Flexible exchange', 'Storage included'],
      color: 'blue',
      icon: 'ri-calendar-line'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=surfboards-and-kitesurfing-equipment-displayed-on-beach-with-ocean-background-essaouira-morocco-colorful-equipment-simple-clean-composition&width=1920&height=1080&seq=equipment-hero-010&orientation=landscape"
            alt="Equipment Rental"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Premium Equipment Rental
          </h1>
          <p className="text-xl text-white/95 mb-8 max-w-2xl mx-auto">
            Top-quality surfboards, kitesurf gear, and accessories for all skill levels
          </p>
        </div>
      </section>

      {/* Packages Section */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Rental Packages
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Save with our convenient package deals
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {packages.map((pkg, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all border-2 border-gray-200">
                <div className={`w-16 h-16 flex items-center justify-center bg-${pkg.color}-100 rounded-full mb-6`}>
                  <i className={`${pkg.icon} text-3xl text-${pkg.color}-600`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{pkg.title}</h3>
                <p className="text-sm text-gray-600 mb-4">{pkg.description}</p>
                <div className="mb-6">
                  <span className="text-3xl font-bold text-gray-900">{pkg.price}</span>
                  <span className="text-base text-gray-600"> {pkg.duration}</span>
                </div>
                <div className="mb-8">
                  <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">Includes:</p>
                  <ul className="space-y-2">
                    {pkg.includes.map((item, idx) => (
                      <li key={idx} className="flex items-center gap-2">
                        <i className="ri-checkbox-circle-fill text-teal-600 text-base"></i>
                        <span className="text-sm text-gray-700">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <a
                  href="/contact"
                  className={`block w-full text-center bg-gradient-to-r from-${pkg.color}-500 to-${pkg.color}-600 text-white py-4 rounded-full font-semibold text-base whitespace-nowrap hover:from-${pkg.color}-600 hover:to-${pkg.color}-700 transition-all shadow-lg hover:shadow-xl cursor-pointer`}
                >
                  Reserve Now
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Equipment Catalog */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Browse Equipment
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Rent individual items or create your own custom package
            </p>
          </div>

          {/* Category Filter */}
          <div className="flex flex-wrap gap-3 justify-center mb-12">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setSelectedCategory(cat.id)}
                className={`px-6 py-3 rounded-full font-semibold text-sm whitespace-nowrap transition-all cursor-pointer ${
                  selectedCategory === cat.id
                    ? 'bg-gradient-to-r from-teal-500 to-teal-600 text-white shadow-lg'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                <i className={`${cat.icon} mr-2`}></i>
                {cat.name}
              </button>
            ))}
          </div>

          {/* Equipment Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredEquipment.map((item, index) => (
              <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all border border-gray-200">
                <div className="w-full h-64 bg-gray-100">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{item.name}</h3>
                  <p className="text-sm text-gray-600 mb-4">{item.description}</p>
                  <div className="mb-4">
                    <span className="text-2xl font-bold text-gray-900">{item.price}</span>
                    <span className="text-sm text-gray-600"> {item.duration}</span>
                  </div>
                  <ul className="space-y-2 mb-6">
                    {item.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center gap-2">
                        <i className="ri-checkbox-circle-fill text-teal-600 text-sm"></i>
                        <span className="text-xs text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <a
                    href="/contact"
                    className="block w-full text-center bg-gradient-to-r from-teal-500 to-teal-600 text-white py-3 rounded-full font-semibold text-sm whitespace-nowrap hover:from-teal-600 hover:to-teal-700 transition-all shadow-lg hover:shadow-xl cursor-pointer"
                  >
                    Reserve
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Rental Info Section */}
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Rental Information
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { title: 'Quality Guaranteed', description: 'All equipment is regularly maintained and inspected', icon: 'ri-shield-check-line', color: 'teal' },
              { title: 'Flexible Duration', description: 'Hourly, daily, or weekly rentals available', icon: 'ri-time-line', color: 'blue' },
              { title: 'Free Delivery', description: 'Equipment delivery to your accommodation', icon: 'ri-truck-line', color: 'orange' },
              { title: 'Expert Advice', description: 'Get recommendations on the best gear for conditions', icon: 'ri-customer-service-2-line', color: 'green' }
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className={`w-16 h-16 flex items-center justify-center bg-${item.color}-100 rounded-full mx-auto mb-4`}>
                  <i className={`${item.icon} text-3xl text-${item.color}-600`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-sm text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-teal-500 to-teal-600">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Ready to Hit the Waves?
          </h2>
          <p className="text-xl text-white/95 mb-8">
            Reserve your equipment today and enjoy the best surf conditions in Essaouira
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <a
              href="/contact"
              className="bg-white text-teal-600 px-8 py-4 rounded-full font-semibold text-base whitespace-nowrap hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl cursor-pointer"
            >
              Reserve Equipment
            </a>
            <a
              href="https://wa.me/212600000000"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 text-white px-8 py-4 rounded-full font-semibold text-base whitespace-nowrap hover:bg-green-600 transition-all shadow-lg hover:shadow-xl cursor-pointer"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              WhatsApp Us
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
